import React from 'react'
import { Row, Cell, IconButton } from '@fs/zion-ui'
import { ArrowCaret } from '@fs/zion-icon'
import { useQueryParams } from '@fs/zion-router'
import { useGroupData, useCoverages, useImageOrganizeModes, useViewMode } from '../../hooks'
import { useSetFocusedIndex } from '../../../../components/groupImageBrowser/hooks'
import transl from './GroupDataHeader.transl'
import SwitchItemButton from './SwitchItemButton'
import styles from './NavigationButtons.styles'

export default function NavigationButtons({ showSwitchItemButton = false }) {
  const { isDivideMode } = useImageOrganizeModes()
  const { group, itemNumber, itemCount, setGroupIndex } = useGroupData()
  const { viewMode } = useViewMode()
  const { setQuery } = useQueryParams({ replaceState: true })
  const { coverages = [] } = useCoverages()
  const setFocusIndex = useSetFocusedIndex()

  const listOfGroups = group?.siblingIdsWithChildren
  const isDividedGroup = itemCount > 1

  const handleNavClick = (isNext) => {
    if (listOfGroups) {
      const nextGroup = isNext ? listOfGroups?.[itemNumber] : listOfGroups?.[itemNumber - 2]

      setQuery({ groupId: nextGroup?.parentId })
      setGroupIndex(isNext ? itemNumber : itemNumber - 2)
      setFocusIndex(0, null, isNext ? itemNumber : itemNumber - 2)
    }
  }

  const isPrevDisabled = coverages?.length === 0 || itemNumber === 1
  const isNextDisabled = coverages?.length === 0 || itemNumber === listOfGroups?.length

  return (
    <>
      {(isDividedGroup || isDivideMode) && viewMode === 'single' && (
        <Row alignY="middle" gutters="xs">
          <Cell>
            <IconButton
              Icon={ArrowCaret}
              iconDirection="backward"
              size="md"
              color="blue"
              emphasis="low"
              title={transl.goToPreviousItem()}
              disabled={isPrevDisabled}
              onClick={() => handleNavClick(false)}
            />
          </Cell>
          <Cell>
            <IconButton
              Icon={ArrowCaret}
              iconDirection="forward"
              size="md"
              color="blue"
              emphasis="low"
              title={transl.goToNextItem()}
              disabled={isNextDisabled}
              onClick={() => handleNavClick(true)}
            />
          </Cell>
          {/* Divider and SwitchItemButton are in separate cells to allow the grid's gutters 
              to handle proper spacing between all elements. If they were in the same cell,
              the divider would be positioned relative to the button rather than being 
              grid-positioned, causing layout issues. Both are conditionally rendered 
              together when showSwitchItemButton is true. */}
          {showSwitchItemButton && (
            <Cell>
              <div css={styles.divider} />
            </Cell>
          )}
          {showSwitchItemButton && (
            <Cell>
              <SwitchItemButton />
            </Cell>
          )}
        </Row>
      )}
    </>
  )
}
